export interface NotificationItem {
  id: string;
  title: string;
  message: string;
  /**
   * Nome do enum na API em PascalCase (ex.: PlatformFeedbackReceived, AutomationExecuted).
   * O front trata por string; valores numéricos legados são normalizados no mapper da API.
   */
  type: string;
  occurredAt: string;
  readAt: string | null;
  isRead: boolean;
  sourceUrl: string | null;
  /** Metadados: objeto inline e/ou resultado de JSON.parse em metadataJson (camelCase na API). */
  metadata: Record<string, unknown> | null;
}

/** Chaves esperadas em metadata para notificações de feedback da plataforma. */
export const PLATFORM_FEEDBACK_NOTIFICATION_TYPE = 'PlatformFeedbackReceived';

export interface NotificationsListResult {
  items: NotificationItem[];
  page: number;
  pageSize: number;
  totalCount: number;
  hasMore: boolean;
}

export interface NotificationsUnreadCount {
  unreadCount: number;
}

export interface NotificationsReadAllResult {
  affectedCount: number;
}
